module.exports = __webpack_public_path__ + "static/boots-outside-b3e22269c2bec2f413c504993f6441c7.jpg";